import axios from 'axios';
import { COBRO_GENERACION_ERROR_CODE } from '@aid/shared';

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

export function getCobroGeneracionErrorCode(error: unknown): string | null {
  if (!axios.isAxiosError(error) || !isRecord(error.response?.data)) {
    return null;
  }

  const code = error.response.data.code;
  return typeof code === 'string' ? code : null;
}

export function isCobroGeneracionInProgressError(error: unknown): boolean {
  return getCobroGeneracionErrorCode(error) === COBRO_GENERACION_ERROR_CODE.EN_PROGRESO;
}
